import { Observable } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit, Input } from '@angular/core';
import { FormatterData, MessageType } from '../../constants/app.constants';
import { SubmitService } from '../../services/submit.service';
import { DestroyableComponent } from '../../common/destroyable.component';
import { LocalStorageService } from '../../services/local-storage.service';
import { ComponentCanDeactivate } from '../../+shared/guards/pending-changes-guard.servie';
import { Document, UpdateApplicationStatusRequest } from '../../jurisdiction/jurisdiction.domain';
import { DocumentsSectionsState } from '../../+grid-application-shared/entities/sections-state/documentsSectionsState';
import { GridApplicationDocumentTypes } from '../../+grid-application-shared/entities/enums/grid-application-document-types.enum';
import { EnvironmentService } from 'src/app/services/environment.service';
import { FormGroup } from '@angular/forms';
import { ReviewSectionHelpers } from 'src/app/+shared/components/review-section/review-section.helpers';
import { GridCompatibilityProcessStatus } from 'src/app/+grid-compatibility/entities/enums/gridCompatibilityProcessStatus';
import { GridCompatibilityOrderProcessService } from 'src/app/+grid-compatibility/services/grid-compatibility-order-process.service';
import { DrrCcdDeviceService } from '../technical-data/technical-data.service';
import { DrrCcdDeviceApplicationDto, DrrCcdDocumentTypes } from '../technical-data/technical-data.domain';
import { ApplicationStepType } from 'src/app/+shared/components/application-steps-generic/application-steps-generic.models';
import { SkStatus } from 'src/app/+shared/enums/skStatus';
import { DrrCcdDataStore } from '../drr-ccd-data.store';

@Component({
  selector: 'app-ccd-drr-documents-form',
  templateUrl: './ccd-drr-documents-form.component.html',
  styleUrls: ['./ccd-drr-documents-form.component.scss'],
})
export class CcdDrrDocumentsFormComponent extends DestroyableComponent implements OnInit, ComponentCanDeactivate {
  @Input() isDetailsView: boolean = false;

  private currentInstallationFlow = this.localStorageService.getItem('installation_flow');

  public isLoading: boolean = false;
  public application_id: number;
  public externalApplicationId: string;
  public requiredDocuments: Document[] = [];
  public otherDocuments: Document[] = [];
  public updateRequest: UpdateApplicationStatusRequest;
  public documentsSectionsState: DocumentsSectionsState;
  public isLockUnlockButtonClicked: boolean = false;
  public commentSectionOrderProcess$: Observable<any>;
  public commentSectionEditableStatuses: Array<number>;
  showAddMoreProductsButton: boolean = this.environmentService.showAddMoreProductsButton[this.currentInstallationFlow];

  private readonly requiredDocumentTypes: GridApplicationDocumentTypes[] = [];

  private role: string;

  public skStatus = 'submitted';
  public preventCanDeactivateCheck: boolean = false;
  public applicationTypeName = 'installation-data.ccd-drr';
  public documentForm: FormGroup;
  public contactPersonData: any;
  public applicationOwnerId: string;
  public currentSkStatus: string;
  public readonly drrCcdApplicationDocumentTypes = DrrCcdDocumentTypes;
  public readonly dateFormat = FormatterData.date;
  ApplicationStepType = ApplicationStepType;
  application: DrrCcdDeviceApplicationDto;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private submitService: SubmitService,
    private localStorageService: LocalStorageService,
    private orderProcessService: GridCompatibilityOrderProcessService,
    private drrCcdApplicationService: DrrCcdDeviceService,
    private environmentService: EnvironmentService,
    private reviewSectionHelpers: ReviewSectionHelpers,
    private store: DrrCcdDataStore
  ) {
    super();
  }

  ngOnInit(): void {
    const urlApplcationId = this.route.snapshot.paramMap.get('id');
    this.role = this.localStorageService.getItem('role');
    this.commentSectionOrderProcess$ = this.orderProcessService.orderProcess$;
    this.commentSectionEditableStatuses = [
      GridCompatibilityProcessStatus.OpenIssue,
      GridCompatibilityProcessStatus.FeedInPermissionExpired,
    ];
    if (this.environmentService.showCustomerPowerOfAttorney) {
      this.requiredDocumentTypes.push(GridApplicationDocumentTypes.CustomerPowerOfAttorney);
    }

    if (urlApplcationId || !this.isDetailsView) {
      this.isLoading = true;
      this.application_id = Number(urlApplcationId) || Number(this.localStorageService.getItem('application_id'));
      this.setDocumentsAndSectionsState(urlApplcationId);
    } else {
      this.application_id = Number(this.localStorageService.getItem('application_id'));
      this.updateRequest = { sk_status: this.skStatus };
      this.requiredDocuments = [...this.requiredDocumentTypes.map(t => new Document(t))];
    }
  }

  canDeactivate(): boolean | Promise<boolean> {
    return this.documentForm?.pristine || this.preventCanDeactivateCheck;
  }

  public setDocumentsAndSectionsState(urlApplcationId: string): void {
    this.isLoading = true;
    this.preventLeak(this.store.getApplicationDto()).subscribe(
      application => {
        this.application = application;
        if (!application) return;
        this.isLoading = false;
      },
      error => {
        this.isLoading = false;
      }
    );
  }

  public submit(options: { redirectAfterSubmit?: boolean } = { redirectAfterSubmit: true }): Promise<void> {
    return new Promise((resolve, reject) => {
      const request = {
        application_id: this.application_id,
        comment: this.documentForm?.value.comments,
        sk_status: SkStatus.submitted,
      };

      this.preventLeak(this.drrCcdApplicationService.updateDrrCcdDeviceApplication(request as any)).subscribe(
        _ => {
          resolve();
          if (options.redirectAfterSubmit) {
            this.preventCanDeactivateCheck = true;
            this.submitService.setMessage(MessageType.REQUEST_SUBMISSION);
            this.router.navigate(['/submitted']);
          }
        },
        err => {
          reject(err);
        }
      );
    });
  }

  public initDocumentForm(documentForm: FormGroup) {
    this.documentForm = documentForm;
  }
}
